import { FC, useEffect, useState } from "react";
import { getAllAccreditations } from "services/api";
import { IAccreditation } from "services/models";
import AccreditationCard from "./AccreditationCard";
import LoadingModal from "components/LoadingModal/LoadingModal";

const AccreditationItems: FC = () => {
  const [accreditations, setAccreditations] = useState<IAccreditation[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllAccreditations()
      .then((data) => {
        setAccreditations(data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch accreditations");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <LoadingModal showModal={loading} />;
  }

  if (error) {
    return <div>{error}</div>;
  }
  // Sort sections by order
  accreditations.sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className={`nc-SectionLatestPosts relative`}>
      <div className="flex flex-col lg:flex-row">
        <div className="w-full">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 mb-8">
            Accreditations, certificates, memberships
          </h2>
          <div className={`grid gap-6 md:gap-8 grid-cols-1`}>
            {accreditations.map((accreditation) => (
              <AccreditationCard
                key={accreditation._id}
                accreditation={accreditation}
              />
            ))}
          </div>
          <div className="flex flex-col mt-12 md:mt-20 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center"></div>
        </div>
      </div>
    </div>
  );
};

export default AccreditationItems;
